// useReportFilters.js
// Fetches the current user's report scope and the department list they're
// allowed to filter by (empty for department admin — they're already
// locked to one). Reports that don't support department filtering can
// ignore the departments/role fields entirely.
//
// get_report_filters.php only recognizes the company-hierarchy roles, so a
// report page that's also reachable by trainer/trainingadmin (who have
// their own, different filter dimensions) should pass enabled=false for
// those roles — otherwise every page load fires a request that's a
// designed-in 403 for them, which just adds console/network noise.

import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function useReportFilters(enabled = true) {
  const [scope, setScope] = useState({ role: null, companyId: null, departmentId: null, departments: [] });
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) return;
    fetch(`${API_BASE_URL}/reports/get_report_filters.php`, { credentials: 'include' })
      .then(response => response.json())
      .then(data => setScope(data))
      .catch(error => console.error('Error fetching report filters:', error))
      .finally(() => setLoading(false));
  }, [enabled]);

  return { ...scope, loading };
}

export default useReportFilters;
